import { useLocale, useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import heartHealthPress from '@/app/[locale]/heart-health/_data/heartHealthPress';
import ArticleCardsModule from '@/app/components/ArticleCardsModule';
import ArticleCardTag from '@/app/components/ArticleCardsModule/ArticleCardTag';

const HeartHealthPress = (): JSX.Element => {
  const t = useTranslations();
  const locale = useLocale();
  const articles = heartHealthPress(locale);

  const handleLinkClick = async (
    event: React.MouseEvent<HTMLAnchorElement>,
  ): Promise<void> => {
    const { href } = event.currentTarget;
    await window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'read more',
      location: 'heart health press',
      path: href,
    });
  };
  return (
    <ArticleCardsModule
      {...articles}
      data-cy="heart-health-press"
      eyebrowText="pulse_blog_eyebrow"
      eyebrowTextColor="light"
      imageTag={() => (
        <ArticleCardTag tag="featured_article_tag" textColor="sandstone-500" />
      )}
      mobileSliderAriaLabels={[
        t('press_section_slide_label_cardiovascular'),
        t('press_section_slide_label_heart_rate'),
        t('press_section_slide_label_heart_rate_accuracy'),
      ]}
      onClick={handleLinkClick}
      swipeableDotsProps={{
        activeColor: 'sandstone-200',
        color: 'sandstone-500',
      }}
      wrapperClass="bg-brown-500 text-brown-500"
    />
  );
};

export default HeartHealthPress;
